export class BasicInfoService {
    constructor($q) {
        'ngInject';
        this.$q = $q;
        this.emailPattern = '^[_a-zA-Z0-9](?:[.+-]?[_A-Za-z0-9\'-]){0,53}@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[.][a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?){0,4}[.][a-zA-Z]{2,20}';
        this.clearBasicInfo();
    }

    setBasicInfo(newInfo) {
        this.data = angular.copy(newInfo);
    }

    clearBasicInfo() {
        this.data = {
            firstName: null,
            lastName: null,
            phoneNumber: null,
            email: null,
        };
    }

    isValid(data = this.data) {
        return data.firstName &&
            data.lastName &&
            data.email &&
            data.phoneNumber;
    }

    validate() {
        return this.isValid() ? this.$q.resolve() : this.$q.reject();
    }

}
